import { createSlice } from "@reduxjs/toolkit";
import { fetchRecordedContactsInsights } from "./recordedContactsInsightsThunks";
const recordedContactsInsightsSlice = createSlice({
  name: "recordedContactsInsights",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {
    resetInsights(state) {
      state.loading = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecordedContactsInsights.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecordedContactsInsights.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRecordedContactsInsights.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetInsights } = recordedContactsInsightsSlice.actions;
export default recordedContactsInsightsSlice.reducer;
